import React from 'react';
import Input from './input';

const NumberInput = ({ ...props }) => {
  return <Input {...props} type='number' className='a-text-field no_arrow' />;
};

export default NumberInput;
